import React from "react";
import { OZEL_PRODUCTS } from "./adminStyles";

/**
 * Ozel mod render bloku - urun bazli ayarlar
 * Hesaplama backend'de yapilir, bu sadece pure form input rendering.
 * isDesktop=true: ALIS|SATIS yan yana iki kolon.
 * isDesktop=false: ALIS uste, SATIS alta (mobil-friendly tek kolon).
 */
const OzelInputs = ({ isDesktop = true, priceSource, ozelConfig, setOzelConfig }) => {
  const cardStyle = isDesktop
    ? { backgroundColor: '#f5f5f5', padding: '14px', borderRadius: '10px', marginBottom: '12px', border: '1px solid #ddd' }
    : { backgroundColor: '#fff', padding: '12px', borderRadius: '8px', marginBottom: '10px', border: '1px solid #ddd' };
  const selectFontSize = isDesktop ? '16px' : '16px';
  const inputFontSize = isDesktop ? '14px' : '16px';
  const inputPadding = isDesktop ? '8px' : '7px';

  const renderAlisSatisGrid = (p, mode, valLabel) => {
    const useTwoCol = isDesktop;
    const alisBlock = (
      <div style={useTwoCol ? { flex: 1, borderRight: '2px solid #ddd', paddingRight: '10px' } : { marginBottom: '8px' }}>
        <p style={{ fontSize: '11px', fontWeight: 'bold', color: '#e74c3c', marginBottom: useTwoCol ? '6px' : '4px' }}>ALIS</p>
        <div style={{ display: 'flex', gap: '6px' }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: '10px', color: '#666' }}>{mode === 'tl_iscilik' ? 'Iscilik' : valLabel}</label>
            <input
              type={mode === 'tl_iscilik' ? 'number' : 'text'}
              inputMode={mode === 'tl_iscilik' ? undefined : 'decimal'}
              step={mode === 'tl_iscilik' ? undefined : 'any'}
              value={ozelConfig[mode === 'tl_iscilik' ? `${p.key}_alis_iscilik` : `${p.key}_alis_val`] || ''}
              onChange={e => setOzelConfig(prev => ({ ...prev, [mode === 'tl_iscilik' ? `${p.key}_alis_iscilik` : `${p.key}_alis_val`]: e.target.value }))}
              style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '1px solid #ccc', fontSize: useTwoCol ? '13px' : '16px' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: '10px', color: '#666' }}>Marj</label>
            <input
              type="number"
              value={ozelConfig[`${p.key}_alis_marj`] || ''}
              onChange={e => setOzelConfig(prev => ({ ...prev, [`${p.key}_alis_marj`]: e.target.value }))}
              style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '1px solid #ccc', fontSize: useTwoCol ? '13px' : '16px' }}
            />
          </div>
        </div>
      </div>
    );
    const satisBlock = (
      <div style={useTwoCol ? { flex: 1 } : {}}>
        <p style={{ fontSize: '11px', fontWeight: 'bold', color: '#27ae60', marginBottom: useTwoCol ? '6px' : '4px' }}>SATIS</p>
        <div style={{ display: 'flex', gap: '6px' }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: '10px', color: '#666' }}>{mode === 'tl_iscilik' ? 'Iscilik' : valLabel}</label>
            <input
              type={mode === 'tl_iscilik' ? 'number' : 'text'}
              inputMode={mode === 'tl_iscilik' ? undefined : 'decimal'}
              step={mode === 'tl_iscilik' ? undefined : 'any'}
              value={ozelConfig[mode === 'tl_iscilik' ? `${p.key}_satis_iscilik` : `${p.key}_satis_val`] || ''}
              onChange={e => setOzelConfig(prev => ({ ...prev, [mode === 'tl_iscilik' ? `${p.key}_satis_iscilik` : `${p.key}_satis_val`]: e.target.value }))}
              style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '1px solid #ccc', fontSize: useTwoCol ? '13px' : '16px' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: '10px', color: '#666' }}>Marj</label>
            <input
              type="number"
              value={ozelConfig[`${p.key}_satis_marj`] || ''}
              onChange={e => setOzelConfig(prev => ({ ...prev, [`${p.key}_satis_marj`]: e.target.value }))}
              style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '1px solid #ccc', fontSize: useTwoCol ? '13px' : '16px' }}
            />
          </div>
        </div>
      </div>
    );
    return useTwoCol ? (
      <div style={{ display: 'flex', gap: '10px' }}>{alisBlock}{satisBlock}</div>
    ) : (
      <>{alisBlock}{satisBlock}</>
    );
  };

  return (
    <>
      <h3 style={{ textAlign: 'center', color: '#09301E', fontSize: '15px', marginBottom: '15px' }}>OZEL Mod - Urun Bazli Ayarlar</h3>
      <p style={{ color: '#888', fontSize: '12px', textAlign: 'center', marginBottom: '15px' }}>Her urun icin hesaplama yontemini secip degerleri girin</p>
      {OZEL_PRODUCTS.map(p => {
        const mode = ozelConfig[`${p.key}_mode`] || 'ozan_marj';
        const isGram = p.type === 'gram';
        const isBilezik = p.type === 'bilezik';
        const modeOptions = isGram
          ? [{ v: 'ozan_marj', l: 'Ozan+Marj' }, { v: 'milyem', l: 'Milyem' }, { v: 'tl_iscilik', l: 'TL Iscilik' }]
          : [{ v: 'ozan_marj', l: 'Ozan+Marj' }, { v: 'has', l: 'HAS' }, { v: 'tl_iscilik', l: 'TL Iscilik' }];
        const valLabel = isGram ? 'Milyem' : 'HAS';
        return (
          <div key={p.key} style={cardStyle}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px', flexWrap: 'wrap', gap: '8px' }}>
              <h4 style={{ color: '#09301E', fontSize: isDesktop ? '16px' : '14px', fontWeight: 'bold', margin: 0 }}>{p.label}</h4>
              {!isBilezik && (
                <select value={mode} onChange={e => setOzelConfig(prev => ({ ...prev, [`${p.key}_mode`]: e.target.value }))} data-testid={`ozel-${p.key}-mode`}
                  style={{ padding: isDesktop ? '8px 14px' : '6px 10px', borderRadius: '6px', border: '2px solid #DA9F54', fontSize: selectFontSize, fontWeight: 'bold', backgroundColor: '#fff', cursor: 'pointer' }}>
                  {modeOptions.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                </select>
              )}
            </div>
            {isBilezik && (
              <div>
                {priceSource !== 'altinkaynak' && (
                  <div>
                    <label style={{ fontSize: '12px', color: '#09301E', fontWeight: 'bold' }}>Carpan</label>
                    <input type="text" inputMode="decimal" value={ozelConfig.bilezik_carpan ?? 0.912}
                      onChange={e => setOzelConfig(prev => ({ ...prev, bilezik_carpan: e.target.value }))}
                      data-testid="ozel-bilezik-carpan"
                      style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '1px solid #ccc', fontSize: inputFontSize }} />
                  </div>
                )}
                {priceSource === 'altinkaynak' && (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                    <div>
                      <label style={{ fontSize: '12px', color: '#09301E', fontWeight: 'bold' }}>Hesaplama</label>
                      <select value={ozelConfig.bilezik_calc_mode || 'milyem'} onChange={e => setOzelConfig(prev => ({ ...prev, bilezik_calc_mode: e.target.value }))} data-testid="ozel-bilezik-calc-mode"
                        style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '2px solid #DA9F54', fontSize: selectFontSize, fontWeight: 'bold', backgroundColor: '#fff', cursor: 'pointer' }}>
                        <option value="milyem">HAS x Milyem</option>
                        <option value="tl_marj">TL Marj</option>
                      </select>
                    </div>
                    {(ozelConfig.bilezik_calc_mode || 'milyem') === 'milyem' && (
                      <div style={{ flex: 1 }}>
                        <label style={{ fontSize: '12px', color: '#09301E', fontWeight: 'bold' }}>Milyem</label>
                        <input type="text" inputMode="decimal" value={ozelConfig.bilezik_milyem ?? 0.912}
                          onChange={e => setOzelConfig(prev => ({ ...prev, bilezik_milyem: e.target.value }))}
                          data-testid="ozel-bilezik-milyem"
                          style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '1px solid #ccc', fontSize: inputFontSize }} />
                      </div>
                    )}
                    {(ozelConfig.bilezik_calc_mode || 'milyem') === 'tl_marj' && (
                      <div style={{ flex: 1 }}>
                        <label style={{ fontSize: '12px', color: '#e74c3c', fontWeight: 'bold' }}>TL Marj</label>
                        <input type="text" inputMode="decimal" value={ozelConfig.bilezik_alis_marj || ''}
                          onChange={e => setOzelConfig(prev => ({ ...prev, bilezik_alis_marj: e.target.value }))}
                          data-testid="ozel-bilezik-alis-marj"
                          style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '1px solid #ccc', fontSize: inputFontSize }} />
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            {!isBilezik && mode === 'ozan_marj' && (
              <div style={isDesktop ? { display: 'flex', gap: '10px' } : {}}>
                <div style={isDesktop ? { flex: 1 } : { marginBottom: '8px' }}>
                  <label style={{ fontSize: '11px', color: '#e74c3c', fontWeight: 'bold' }}>ALIS Marj</label>
                  <input type="number" value={ozelConfig[`${p.key}_alis_marj`] || ''}
                    onChange={e => setOzelConfig(prev => ({ ...prev, [`${p.key}_alis_marj`]: e.target.value }))}
                    style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '1px solid #ccc', fontSize: inputFontSize }} />
                </div>
                <div style={isDesktop ? { flex: 1 } : {}}>
                  <label style={{ fontSize: '11px', color: '#27ae60', fontWeight: 'bold' }}>SATIS Marj</label>
                  <input type="number" value={ozelConfig[`${p.key}_satis_marj`] || ''}
                    onChange={e => setOzelConfig(prev => ({ ...prev, [`${p.key}_satis_marj`]: e.target.value }))}
                    style={{ width: '100%', padding: inputPadding, borderRadius: '6px', border: '1px solid #ccc', fontSize: inputFontSize }} />
                </div>
              </div>
            )}
            {!isBilezik && (mode === 'milyem' || mode === 'has') && renderAlisSatisGrid(p, mode, valLabel)}
            {!isBilezik && mode === 'tl_iscilik' && renderAlisSatisGrid(p, mode, valLabel)}
          </div>
        );
      })}
    </>
  );
};

export default OzelInputs;
